import React from "react";
import Searchbar from "../../Components/Searchbar/Searchbar";
import StatesData from "../../Components/NationalParksMap/StatesData";
import ChatBotComponent from "../../Components/ChatBot/ChatBotComponent";
const HomePage = () => {
  return (
    <div>
      <Searchbar className="py-5" />
      <StatesData />
      <ChatBotComponent />
    </div>
  );
};
export default HomePage;
